import {createBrowserHistory} from 'history'
import {routerMiddleware} from 'connected-react-router'
import {createRootReducer} from '../redux'

export const history = createBrowserHistory()

import { configureStore } from '@reduxjs/toolkit'

export const store = configureStore({
    reducer: createRootReducer(history),
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(routerMiddleware(history)),
    devTools: process.env.NODE_ENV !== 'production',
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

// export default function configureStore(preloadedState: { router?: { location: { query: { [x: string]: string | undefined }; pathname: string; search: string; state: unknown; hash: string; key?: string | undefined }; action: Action } | undefined } | undefined) {
//     return createStore(
//         createRootReducer(history), // root reducer with router state
//         preloadedState,
//         compose(
//             applyMiddleware(
//                 routerMiddleware(history), // for dispatching history actions
//                 // ... other middlewares ...
//             ),
//         ),
//     )
// }
